const UserFilled = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="100%"
      height="100%"
      fill="none"
      viewBox="0 0 24 24"
    >
      <circle cx="12" cy="6" r="4" fill="currentColor"></circle>
      <ellipse cx="12" cy="17" fill="currentColor" rx="7" ry="4"></ellipse>
    </svg>
  );
};

export default UserFilled;
